<template>
  <div class="admin-breadcrumb-container">
    <span
      v-for="(item, i) in breadcrumbs"
      :key="i"
      :class="{
        'admin-breadcrumb-active': item.active,
        'admin-breadcrumb-has-link': item.link ? true : false,
      }"
      @click="move(item)"
    >
      {{ checkName(item.name) }}
      <span v-if="i != breadcrumbs.length - 1">/</span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumb;
    },
  },
  methods: {
    move(item) {
      if (item.link) {
        this.$router.push(item.link);
      }
    },
    checkName(name) {
      if (name.includes(":")) {
        const params = name.substring(name.indexOf(":") + 1);
        return this.$route.params[params];
      }
      if (name.includes("#")) {
        return this.capitalizeFirstLetter(location.hash.substring(1));
      } else return name;
    },
  },
};
</script>

<style scoped>
.admin-breadcrumb-container {
  font-size: 10px;
  font-weight: bold;
  color: grey;
  margin-bottom: 20px;
  padding: 0 1.0416666667vw;
  letter-spacing: 0.015em;
}

.admin-breadcrumb-active {
  color: black;
}

.admin-breadcrumb-has-link {
  cursor: pointer;
}

/* button {
  border: none;
  background-color: transparent;
} */
</style>
